import RoomPage from '../RoomPage';

const InstructorRoom = () => {
  return (
    <RoomPage
      roomName="Instructor"
      roomTitle="暗闇ゆるヨガ"
      description="暗い部屋で、ゆるく、静かに。できなくてもいい、無理しなくていい。RYT200認定のインストラクターによる、頑張らないヨガ。"
      heroGradient={{
        from: '#021A16',
        to: '#031F1A',
      }}
      works={[
        {
          title: '暗闇ヨガセッション',
          description: '照明を落とした空間でのゆるいヨガ',
        },
        {
          title: 'プライベートレッスン',
          description: 'あなたのペースに合わせた個別指導',
        },
        {
          title: 'オンラインヨガ',
          description: 'オンラインでのヨガをして、ヨガを楽しんでもらいます。',
        },
      ]}
    />
  );
};

export default InstructorRoom;
